import { useEffect } from "react"; 
import { Container, Typography } from "@mui/material";

import QuoteFormHeader from "../components/QuoteFormHeader";
import VehicleData from "../../vehicle/components/VehicleInitialData";
import DriverData from "../../driver/components/DriverInitialData";
import ContractorInitialData from "../../contractor/components/ContractorInitialData";
import TermsAndConditions from "../components/TermsAndConditions";
import QuoteButton from "../components/QuoteButton"

import { trackEventStep1View } from "../../../utils/analytics";

const QuoteForm = () => {

  useEffect(() => { 
    trackEventStep1View().catch(e => console.warn("Error en analítica:", e)); 
  }, []);

  return (
    <Container
        maxWidth="md"
        disableGutters={{ 
            xs: true, 
            md: false 
        }}
        sx={{
            py: 2,
            px: 2
        }}>
        <QuoteFormHeader />
        <VehicleData />
        <DriverData />
        <ContractorInitialData />
        <TermsAndConditions />
        <QuoteButton />
    </Container>
  );
};

export default QuoteForm;
